import React from 'react';
import moment from 'moment';
import Breadcrumbs from '../../../atoms/Breadcrumbs';
import FileTitle from '../../../atoms/FileTitle';
import TableIcon from '../../../atoms/Icons/TableIcon';
import { DOCUMENT_LIBRARY_CHAT_DIR } from '../../../const';
import DropdownMenu from '../../DropdownMenu';
import AddFolder from '../../Folder/Add';
import DownloadRootButton from '../../Folder/DownloadRootButton';
import { BlackText, SecActions, StyledTable, Title } from './styles';
export default function FilesList({
  isUploadingDisabled,
  chatFilesReadonly,
  files,
  isLoading,
  isProjectAnonymous,
  path,
  projectId,
  refreshFileList,
  setPath
}) {
  const columns = [{
    title: '',
    render: file => <TableIcon setPath={setPath} file={file} />
  }, {
    title: 'Name',
    render: file => <FileTitle file={file} setPath={setPath} />,
    sorter: {
      compare: (f1, f2) => f1.name.length - f2.name.length,
      multiple: 3
    }
  }, {
    title: 'Submitted by',
    dataIndex: 'creator',
    render: creator => <BlackText>{creator}</BlackText>,
    sorter: {
      compare: (f1, f2) => f1.creator.localeCompare(f2.creator),
      multiple: 2
    }
  }, {
    title: 'Date Created',
    dataIndex: 'date_uploaded',
    render: item => <BlackText>{item && moment(item).format('MM/DD/YYYY')}</BlackText>,
    sorter: {
      compare: (f1, f2) => moment(f1.date_uploaded).unix() - moment(f2.date_uploaded).unix(),
      multiple: 2
    }
  }, {
    align: 'left',
    render: file => !isLoading && !file.path.startsWith(DOCUMENT_LIBRARY_CHAT_DIR) && <DropdownMenu file={file} projectId={projectId} disableMove={chatFilesReadonly} refreshFileList={refreshFileList} />
  }];
  return <section data-testid="FileList">
      <Title>{chatFilesReadonly ? 'Chat Files' : 'All Uploads'}</Title>
      <SecActions>
        {!chatFilesReadonly && <>
            <AddFolder path={path} projectId={projectId} refreshFileList={refreshFileList} isUploadingDisabled={isUploadingDisabled} />
            <DownloadRootButton projectId={projectId} />
          </>}
        <Breadcrumbs path={path} setPath={setPath} isLoading={isLoading} />
      </SecActions>
      <StyledTable columns={columns} dataSource={files} key="key" loading={isLoading} />
    </section>;
}